import { observer } from "mobx-react-lite";
import useGetLeadColor from "../../hooks/useGetLeadColor";
import { LeadStatus } from "../../interfaces/ILead";
import { leadStatusToString } from "../../utils/enumUtils";
import styles from "./LeadStatusWithIcon.module.css";

function LeadStatusWithIcon({ status, className }: ILeadStatusWithIconProps) {
    const getLeadColor = useGetLeadColor();

    return (
        <div className={[styles.container, className].join(" ")}>
            <div className={styles.icon} style={{ backgroundColor: getLeadColor(status) }} />
            {leadStatusToString(status)}
        </div>
    );
}

export default observer(LeadStatusWithIcon);

interface ILeadStatusWithIconProps {
    status: LeadStatus;
    className?: string;
}